import React from 'react';
import { DAYS_OF_WEEK, HOURS } from './constants';

const getColor = (score) => {
  if (score >= 80) return 'bg-green-500';
  if (score >= 60) return 'bg-green-400';
  if (score >= 40) return 'bg-yellow-400';
  if (score >= 20) return 'bg-orange-400';
  if (score > 0) return 'bg-red-400';
  return 'bg-muted';
};

export const EngagementHeatmap = ({ data, platform }) => {
  if (!data || !data.heatmap) return null;

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs">
        <thead>
          <tr>
            <th className="p-1 text-left">Hora</th>
            {DAYS_OF_WEEK.map(day => (
              <th key={day.value} className="p-1 text-center">{day.label.slice(0, 3)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {HOURS.filter(h => h.value >= 6 && h.value <= 23).map(hour => (
            <tr key={hour.value}>
              <td className="p-1 text-muted-foreground">{hour.label}</td>
              {DAYS_OF_WEEK.map(day => {
                const score = data.heatmap[day.value]?.[hour.value.toString()] || 0;
                return (
                  <td key={day.value} className="p-1">
                    <div 
                      className={`w-full h-6 rounded ${getColor(score)} flex items-center justify-center text-white font-medium`}
                      title={`${day.label} ${hour.label}: Score ${score}`}
                    >
                      {score > 0 ? Math.round(score) : ''}
                    </div>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EngagementHeatmap;
